import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom"; 
import addCampiButton from "../../assets/addCampiButton.png";
import addCursoButton from "../../assets/addCursoButton.png";
import vagasWhite from "../../assets/vagasWhite.png";
import concessionBlue from "../../assets/concessionBlue.png";
import termo from "../../assets/termo.png";

// Container principal que ocupa o restante da tela
const Container = styled.div`
  width: calc(70% - 300px); 
  margin-top: 20px;
  background-color: #f9f9f9;
  padding-left: 30px;

  @media (max-width: 768px) {
    margin-left: 150px; 
    width: calc(100% - 150px);
  }

  @media (max-width: 480px) {
    margin-left: 0; 
    width: 100%; 
  }
`;

// Contêiner para mensagens
const MessageContainer = styled.div`
  margin-bottom: 20px; 

  @media (max-width: 768px) {
    text-align: center;
  }
`;

// Texto de mensagem
const Message = styled.p`
  font-size: 15px;
  color: #555555;
  text-align: left;
  margin-bottom: 10px; 

  @media (max-width: 768px) {
    font-size: 14px;
    text-align: center;
  }
`;

// Botão base estilizado
const Button = styled.button`
  padding: 0px;
  padding-right: 5px;
  padding-left: 5px;
  width: 150px;
  height: 100px;
  border: none;
  border-radius: 8px;
  background-color: #6AB8A8;
  color: white;
  font-size: 13px;
  cursor: pointer;
  text-align: center;
  margin-top: 2px;
  transition: transform 0.2s ease, background-color 0.2s ease;

  &:hover {
    background-color: #5ea89c;
  }

  img {
    width: 40px;
    height: 40px;
    margin-top: 15px;
    margin-left: 45px;
    margin-bottom: -10px; 
    position: relative;
    display: flex;
    justify-content: center;
    top: -20px; 
  }

  .material-symbols-outlined {
    width: 40px;
    height: 40px;
    margin-top: 15px;
    margin-left: 45px;
    margin-bottom: -10px; 
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -20px; 
    font-size: 40px;
  }

  @media (max-width: 768px) {
    width: 120px; 
    height: 80px; 
    padding: 0px;
  }
`;

// Botão para Campis
const CampisButton = styled(Button)`
  margin-right: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-bottom: 20px;
  }
`;

// Botão para Cursos
const CursosButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const UsuariosButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const VagasButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const ConcessoesButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const TermoCompromissoButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const EstabelecimentosButton = styled(Button)`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const DashboardContent = ({ cargoId }) => {
  const navigate = useNavigate();

  const getButtonText = (type) => {
    if (cargoId === 1) {
      switch (type) {
        case 'campis':
          return 'Campis';
        case 'cursos':
          return 'Cursos';
        case 'usuarios':
          return 'Usuários';
        case 'vagas':
          return 'Cadastrar Vagas';
        case 'estabelecimentos':
          return 'Estabelecimentos de Saúde';
        default:
          return '';
      }
    } else if (cargoId === 2 || cargoId === 3) {
      switch (type) {
        case 'campis':
          return 'Campis';
        case 'cursos':
          return 'Cursos';
        case 'usuarios':
          return 'Cadastrar Usuários';
        case 'vagas':
          return 'Vagas Disponibilizadas';
        case 'concessoes':
          return 'Concessão / Validações';
        default:
          return '';
      }
    } else {
      switch (type) {
        case 'campis':
          return 'Cadastrar Campis';
        case 'cursos':
          return 'Cadastrar Cursos';
        case 'usuarios':
          return 'Cadastrar Usuários';
        case 'vagas':
          return 'Vagas Disponibilizadas';
        case 'concessoes':
          return 'Concessão / Validações';
        default:
          return '';
      }
    }
  };

  return (
    <Container>
      <MessageContainer>
        <Message>
          {cargoId === 1 
            ? "Acesse os campis, cursos e usuários da instituição de ensino através dos botões abaixo ou pelo menu lateral"
            : "Solicite vagas e acompanhe o processo de concessões e validações no menu lateral."
          }
        </Message>
      </MessageContainer>

      <div style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", paddingTop: "0px" }}>
        {cargoId === 1 && (
          <>
            <EstabelecimentosButton onClick={() => navigate("/EstabelecimentosSaude")}>
              <span className="material-symbols-outlined">domain</span>
              {getButtonText('estabelecimentos')}
            </EstabelecimentosButton>
            <CampisButton onClick={() => navigate("/Campis")}>
              <img src={addCampiButton} alt="" />
              {getButtonText('campis')}
            </CampisButton>
            <CursosButton onClick={() => navigate("/Cursos")}>
              <img src={addCursoButton} alt="" />
              {getButtonText('cursos')}
            </CursosButton>
            <UsuariosButton onClick={() => navigate("/UsersAtivos")}>
              <span className="material-symbols-outlined">group</span>
              {getButtonText('usuarios')}
            </UsuariosButton>
            <VagasButton onClick={() => navigate("/CadastrarVagasEstagio2")}>
              <img src={vagasWhite} alt="" />
              {getButtonText('vagas')}
            </VagasButton>
          </>
        )}
        {(cargoId === 2 || cargoId === 3) && (
          <>
            <CampisButton onClick={() => navigate("/Campis")}>
              <img src={addCampiButton} alt="" />
              {getButtonText('campis')}
            </CampisButton>
            <CursosButton onClick={() => navigate("/Cursos")}>
              <img src={addCursoButton} alt="" />
              {getButtonText('cursos')}
            </CursosButton>
          </>
        )}
        {(cargoId === 2 || cargoId === 3) && (
          <>
            <VagasButton onClick={() => navigate("/VagasDisponibilizadas")}>
              <img src={vagasWhite} alt="" />
              {getButtonText('vagas')}
            </VagasButton>
            <ConcessoesButton onClick={() => navigate("/Concessoes")}>
              <img src={concessionBlue} alt="" />
              {getButtonText('concessoes')}
            </ConcessoesButton>
          </>
        )}
        {(cargoId === 1 || cargoId === 2 || cargoId === 3) && (
          <TermoCompromissoButton onClick={() => navigate("/TermoCompromisso")}>
            <img src={termo} alt="" />
            Termo de Compromisso
          </TermoCompromissoButton>
        )}
      </div>
    </Container>
  );
};

export default DashboardContent;
